import { useState } from 'react';

export interface Rule {
	required: boolean;
	message?: string;
}

export default function useFormValidation<T extends Record<string, any>>(
	initialValues: T,
	rules: Record<keyof T, Rule[]>,
) {
	const [values, setValues] = useState<T>(initialValues);
	const [errors, setErrors] = useState<Record<keyof T, string | string[]>>(
		{} as Record<keyof T, string>,
	);

	function validate(callback?: (errors: Record<keyof T, string | string[]>) => void) {
		let valid = true;
		const newErrors = {} as Record<keyof T, string>;

		for (const key in rules) {
			const value = values[key];
			const fieldRules = rules[key];

			for (const rule of fieldRules) {
				if (rule.required) {
					let errors = null;

					if (!value) errors = rule.message || '';
					if (Array.isArray(value)) {
						if (key === 'campaignSegment' && value.length === 0) {
							errors = rule.message || '';
						} else {
							errors = value.map((v: any) => {
								if (!v) return rule.message || '';
								return '';
							});
						}
					}

					if (errors) {
						newErrors[key as keyof T] = errors;
						valid = false;
						break;
					}
				}
			}
		}

		setErrors(newErrors);
		if (callback) callback(newErrors);
		return valid;
	}

	function resetValidation() {
		setErrors({} as Record<keyof T, string>);
	}

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setValues((prev) => ({ ...prev, [name]: value }));
		if (errors[name as keyof T]) {
			// Clear the error for the field if the value changes
			setErrors((prev) => ({ ...prev, [name as keyof T]: '' }));
		}
	};

	return { values, errors, handleChange, validate, resetValidation };
}
